export default "__VITE_ASSET__164ae235__"